import React from 'react';

const NoPermissionsPage = () => {
  return <div>NoPermissionsPage</div>;
};

export default NoPermissionsPage;
